import React from "react";

function EyeNoData() {
  return (
    <div className="zooming">
      <div className="eye-parento">
        <div className="eye-parento-4"></div>
        <div className="eye-parento-2">
          <div className="eye-parento-3"></div>
        </div>
      </div>
    </div>
  );
}

export default EyeNoData;
